<template>
  <span class="ic" :class="{ pointer }" @click="$emit('click', $event)">
    <i :class="'i-' + name"></i>
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: ['name', 'pointer'],
}
</script>

<style lang="scss">
@import '~style/variables';
@import '../../style/icons/style';

.ic {
  position: relative;
  > .cornered {
    font-size: 60%;
    bottom: 0;
    position: absolute;
    right: 0;
  }
  &.pointer {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Icon.vue